import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { removeActionTypes }    from 'Utils/ReducerUtility';
import { IEmployeeState }       from 'Redux/Slices/Employee/EmployeeSlice';

export const removeEmployeeFromOrganisationRequest = (state: Draft<IEmployeeState>, { type }: PayloadAction<{
  employeeId: string,
  organisationId: string
}>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const removeEmployeeFromOrganisationSuccess = (state: Draft<IEmployeeState>, { type, payload }: PayloadAction<{ organisationId: string }>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);

  const entries = { ...state.entries };
  entries[payload.organisationId] && delete entries[payload.organisationId];

  state.entries = entries;
  state.maxCount = state.maxCount - 1;
};

export const removeEmployeeFromOrganisationFailure = (state: Draft<IEmployeeState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
